// removed by extract-text-webpack-plugin
module.exports = {"timerContainer":"timerContainer__2D5qZ","timerImage":"timerImage__1IqSd"};


//////////////////
// WEBPACK FOOTER
// ./components/partial/layers/countdownTimer/style.css
// module id = KhkQ
// module chunks = 446